import React from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SignUpModal from '../components/auth/SignUpModal';

const SignUp: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname ?? '/';
  const redirectPath = from === '/chart' ? '/' : from;

  if (currentUser) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <SignUpModal
        onClose={() => navigate(redirectPath)}
        onSwitchToSignIn={() => navigate('/signin', { state: { from: location.state } })}
      />
    </div>
  );
};

export default SignUp;